import crel from "crel";
export class CheckListItemView {
    constructor(node, view, getPos) {
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.type = node.type;
        this.dom = crel("li", {
            class: `checklist-item ${node.attrs.checked ? "checklist-item-complete" : ""}`,
        }, crel("label", {
            class: "check-box-item-label",
            contenteditable: false,
        }, (this.input = crel("input", {
            class: "checklist-item-checkbox",
            type: "checkbox",
            contenteditable: false,
        })), crel("span", { class: "check-box-item-icon", contenteditable: false })), (this.contentDOM = crel("div", { class: "checklist-item-content" })));
        this.input.checked = node.attrs.checked;
        this.input.addEventListener("click", () => {
            view.dispatch(view.state.tr.setNodeMarkup(getPos(), null, {
                checked: this.input.checked,
            }));
        });
        this.update(node);
    }
    update(node) {
        if (node.type !== this.type) {
            return false;
        }
        const attrs = node.attrs;
        this.input.checked = attrs.checked;
        crel(this.dom, {
            class: `checklist-item ${attrs.checked ? "checklist-item-complete" : ""}`,
        });
        return true;
    }
}
